import React from 'react'
import styled from 'styled-components'
import Loader from 'react-loader-spinner'
import Page from './layouts/Page'

const Wrapper = styled(Page)`
  display: flex;
  justify-content: center;
  align-items: center;
`

const PageLoader: React.FC = () => {
  return (
    <Wrapper>
      <Loader type='TailSpin' color='#fafafa' height={100} width={100} />
    </Wrapper>
  )
}

export default PageLoader
